import { Controller } from "stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  toggle(event) {
    event.preventDefault();

    const locked = this.element.dataset.locked === "true";
    const url = this.element.dataset.lockUrl;
    const canToggle = this.element.dataset.canToggle === "true";

    if (!canToggle) {
      Swal.fire({
        icon: "info",
        title: locked ? "Form is locked" : "Form is unlocked",
        text: locked
          ? "Only a project admin can unlock this form."
          : "Only a project admin can lock this form.",
      });
      return;
    }

    if (locked) {
      this.promptUnlock(url);
    } else {
      this.confirmLock(url);
    }
  }

  confirmLock(url) {
    Swal.fire({
      title: "Lock form?",
      text: "No one will be able to edit this form until a project admin unlocks it.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, lock it",
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitLock(url, { locked: true });
      }
    });
  }

  promptUnlock(url) {
    Swal.fire({
      title: "Unlock form?",
      html: `
        <p class="mb-2">Provide a reason for unlocking. This will be saved in history.</p>
        <textarea id="form-unlock-reason" class="swal2-textarea" placeholder="Reason for unlock..." rows="4"></textarea>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, unlock it",
      preConfirm: () => {
        const reason = document.getElementById("form-unlock-reason")?.value?.trim();
        if (!reason) {
          Swal.showValidationMessage("Please enter a reason to unlock.");
          return false;
        }
        return { reason };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitLock(url, { locked: false, reason: result.value.reason });
      }
    });
  }

  submitLock(url, payload) {
    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.error || "Unable to update form lock.");
        }
        return data;
      })
      .then((data) => {
        Swal.fire({
          icon: "success",
          title: data.message || "Lock updated",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Lock update failed",
          text: error.message,
        });
      });
  }
}
